export const getCollegeBylocation = (data, search) => {
  //data =[] type ="specialty" search="" pero trabaja sobre []
  if (search === "") {
    return [];
  }

  // search = search.toLocaleLowerCase();

  const p1 = data.colleges?.filter((x) =>
    x.location.every((y) => y.includes(search))
  );

  console.log(p1);

  // return data.colleges?.filter((college) => college.location.toLocaleLowerCase() === search.toLocaleLowerCase());
};

export const getCollegeByname = (data, name = "") => {
  if (name === "") {
    return [];
  }

  name = name.toLocaleLowerCase();


  return data.colleges?.filter(college => college.name.toLocaleLowerCase().includes(name));
};
